import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { combineLatest } from "rxjs";

import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";

import { DataService } from "./../../data.service";
import { GUID } from "./../../guid";
import { AppConfig } from "./../../config";
@Component({
  selector: "app-newreporttype",
  templateUrl: "./newreporttype.component.html",
  styleUrls: ["./newreporttype.component.scss"],
})
export class NewreporttypeComponent implements OnInit {
  checkboxValue: boolean;
  checkboxValue2: boolean;
  retrievedObjectName = "";
  nodeMapping: any;
  metaobject: any;
  applicationId: string;
  isLoading = false;
  isError = false;
  errorMessage = "";
  objectName = "";
  metaobjectName = "";
  metaobjectList = [];
  metaobjectList2 = [];
  relatedObject = [];
  relatedObjectId = "";
  relatedObjectName = "";
  relatedObjects: any[] = [];
  relatedObjects2: any[] = [];
  reportTypeId = "";
  reportTypeRelationId = "";
  reportTypeSectionId = "";

  mode = "New";
  metaobjectId = "";
  reporttype = [];
  // id = "";

  guid: GUID;
  categorySelect = [
    { value: "Administrative", label: "Administrative" },
    { value: "Other", label: "Other" },
  ];

  parentObjects: Array<any>;
  // relatedObjects: Array<any>;

  detailForm = this.fb.group({
    // label: "",
    // name: new FormControl({ value: "", disabled: true }, Validators.required),
    // pluralname: "",
    // node: "",
    // code: new FormControl({ value: "", disabled: true }, Validators.required),
    deploymentStatus: ["false"],
    name: ["", Validators.required],
    label: ["", Validators.required],
    description: ["", Validators.required],
    category: ["", Validators.required],
    primaryobject: ["", Validators.required],

    objecttype: "",
    // category: "",
    development: "",
    deployed: "",
    // description: "",
    standard: false,
    parentobjectid: "",
    parentobjectname: "",
    // primaryobject: "",
    relatedobject: "",
    relatedobjectid: "",
    relatedobjectname: "",
    relatedobject2: "",
    relatedobjectid2: "",
    relatedobjectname2: "",
    embeddedobject: false,
    virtualobject: false,
    active: true,
    allowreports: false,
    allowactivities: false,
    trackfieldhistory: false,
    allowsearch: false,
    enablelicensing: false,
    allowworkflow: false,
    notesandattachments: false,
    iconname: "",
  });

  relatedForm = this.fb.group({
    relatedobject: "",
    relatedobjectid: "",
    relatedobjectname: "",
    relatedlevel: 1,
    relatedobject2: "",
    relatedobjectid2: "",
    relatedobjectname2: "",
    relatedlevel2: 2,
    relatedouterjoin: false,
    relatedouterjoin2: false,
    active: true,
    allowreports: false,
    allowactivities: false,
    trackfieldhistory: false,
    allowsearch: false,
    enablelicensing: false,
    allowworkflow: false,
    notesandattachments: false,
    iconname: "",
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService,
    private appConfig: AppConfig,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.reportTypeId = this.route.snapshot.params.id;
      // this.objectName = this.route.snapshot.params.objectname;
    });

    // this.detailForm = this.fb.group({
    //   parentobjectname: ["AcademicSession"],
    // });

    this.updateDeploymentStatus;

    this.applicationId = this.appConfig.defaultapplicationid;

    this.guid = new GUID();

    console.log("mode", this.mode);
    // if (this.mode.toLowerCase() == "new") {
    // } else if (this.mode.toLowerCase() == "edit") {
    //   this.detailForm.controls.name.disable();
    //   this.detailForm.controls.code.disable();
    // }

    console.log(this.detailForm.controls);

    //load parent objects
    this.getActiveObjectsByType().then((res) => {
      console.log("response11111", res);
      console.log("parentobjects", this.parentObjects);

      //this.detailForm.controls.parentobject.patchValue('');
    });

    // this.detailForm
    //   .get("parentobjectname")
    //   .valueChanges.subscribe((objectname) => {
    //     console.log("objectname changed:", objectname);
    //     this.metaobjectName = objectname;
    //   });

    // this.detailForm.get("parentobjectid").valueChanges.subscribe((objectid) => {
    //   console.log("objectid changed:", objectid);
    //   this.metaobjectId = objectid;
    //   this.retrieveLookupFields();
    // });

    combineLatest([
      this.detailForm.get("parentobjectname").valueChanges,
      this.detailForm.get("parentobjectid").valueChanges,
    ]).subscribe(([objectname, objectid]) => {
      console.log("objectname changed:", objectname);
      console.log("objectid changed:", objectid);
      this.metaobjectName = objectname;
      this.metaobjectId = objectid;

      // this.metaobjectList = [];
      // this.metaobjectList.length = 0;

      this.retrieveLookupFields();
    });
    // Listen for changes to the checkbox value
    this.relatedForm.controls["relatedouterjoin"].valueChanges.subscribe(
      (value) => {
        // Update the checkbox value for each object in the relatedObject array
        this.relatedObject
          .filter((obj) => obj.level === 1)
          .forEach((obj) => {
            obj.outerjoin = value;
          });

        console.log(this.relatedObject);
      },
    );

    this.relatedForm.controls["relatedouterjoin2"].valueChanges.subscribe(
      (value) => {
        // Update the checkbox value for each object in the relatedObject array
        this.relatedObject
          .filter((obj) => obj.level === 2)
          .forEach((obj) => {
            obj.outerjoin = value;
          });

        console.log(this.relatedObject);
      },
    );
    // this.retrieveLookupFields();

    this.getReportTypeById();
  }

  updateDeploymentStatus(status: string) {
    console.log(status);
    this.detailForm.patchValue({
      deploymentStatus: status,
    });
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  // relatedObjectChange(event: { value: string; label: any }) {
  //   console.log("relatedObjectChange", event);
  //   if (event.value.trim() != "") {
  //     this.relatedForm.controls["relatedobjectid"].setValue(event.value);
  //     this.relatedObjectId = event.value;
  //     this.relatedForm.controls["relatedobjectname"].setValue(event.label);
  //     this.relatedObjectName = event.label;

  //     // this.relatedObject.push({
  //     //   relatedobjectid: event.value,
  //     //   relatedobjectname: event.label,
  //     //   level:1
  //     // });

  //     const existingIndex = this.relatedObject.findIndex(obj => obj.value === event.value);
  //     if (existingIndex !== -1) {
  //       this.relatedObject.splice(existingIndex, 1, { relatedobjectid: event.value, relatedobjectname: event.label, level:1 });
  //     } else {
  //       this.relatedObject.push({ relatedobjectid: event.value, relatedobjectname: event.label, level:1 });
  //     }

  //     console.log(this.relatedObject)
  //     // this.relatedForm.controls["relatedlevel"].setValue(event.label);

  //     this.retrieveLookupFields2();
  //   } else {
  //     this.relatedForm.controls["relatedobjectid"].setValue("");
  //     this.relatedObjectId = "";
  //     this.relatedForm.controls["relatedobjectname"].setValue("");
  //     this.relatedObjectId = "";
  //   }
  // }

  // relatedObjectChange2(event: { value: string; label: any }) {
  //   console.log("relatedObjectChange2", event);
  //   if (event.value.trim() != "") {
  //     this.relatedForm.controls["relatedobjectid2"].setValue(event.value);
  //     this.relatedForm.controls["relatedobjectname2"].setValue(event.label);

  //     // this.relatedObject.push({
  //     //   relatedobjectid: event.value,
  //     //   relatedobjectname: event.label,
  //     //   level:2
  //     // });

  //     const existingIndex = this.relatedObject.findIndex(obj => obj.value === event.value);
  //     if (existingIndex !== -1) {
  //       this.relatedObject.splice(existingIndex, 1, { relatedobjectid: event.value, relatedobjectname: event.label, level:2 });
  //     } else {
  //       this.relatedObject.push({ relatedobjectid: event.value, relatedobjectname: event.label, level:2 });
  //     }

  //     console.log(this.relatedObject)

  //   } else {
  //     this.relatedForm.controls["relatedobjectid2"].setValue("");
  //     this.relatedForm.controls["relatedobjectname2"].setValue("");
  //   }
  // }

  relatedObjectChange(event: {
    value: string;
    label: any;
    referencefieldname: any;
  }) {
    console.log("relatedObjectChange", event);
    this.relatedObjectName = event.label;
    this.relatedObjectId = event.value;
    if (event.value.trim() !== "") {
      const outerJoin = this.relatedForm.controls["relatedouterjoin"].value;

      this.relatedObject = [];

      const existingIndex = this.relatedObject.findIndex(
        (obj) => obj.level === 1,
      );
      if (existingIndex !== -1) {
        this.relatedObject[existingIndex].checkboxValue = this.checkboxValue;

        // If a record with level 1 already exists, update it
        this.relatedObject[existingIndex] = {
          relatedobjectid: event.value,
          relatedobjectname: event.label,
          referencefieldname: event.referencefieldname,
          level: 1,
          outerjoin: outerJoin,
          // checkboxValue: this.checkboxValue,
        };
      } else {
        // Otherwise, push the new record
        this.relatedObject.push({
          relatedobjectid: event.value,
          relatedobjectname: event.label,
          referencefieldname: event.referencefieldname,
          level: 1,
          outerjoin: outerJoin,
          // checkboxValue: this.checkboxValue
        });
      }

      console.log(this.relatedObject);
      this.retrieveLookupFields2();
    } else {
      // this.relatedForm.controls["relatedobjectid"].setValue("");
      this.relatedObjectId = "";
      // this.relatedForm.controls["relatedobjectname"].setValue("");
      this.relatedObjectId = "";
      this.relatedObject = [];
    }
  }

  relatedObjectChange2(event: {
    value: string;
    label: any;
    referencefieldname: any;
  }) {
    console.log("relatedObjectChange2", event);
    if (event.value.trim() !== "") {
      const outerJoin = this.relatedForm.controls["relatedouterjoin2"].value;

      const existingIndex = this.relatedObject.findIndex(
        (obj) => obj.level === 2,
      );
      if (existingIndex !== -1) {
        // If a record with level 2 already exists, update it
        this.relatedObject[existingIndex] = {
          relatedobjectid: event.value,
          relatedobjectname: event.label,
          level: 2,
          referencefieldname: event.referencefieldname,
          outerjoin: outerJoin,
        };
      } else {
        // Otherwise, push the new record
        this.relatedObject.push({
          relatedobjectid: event.value,
          relatedobjectname: event.label,
          level: 2,
          referencefieldname: event.referencefieldname,
          outerjoin: outerJoin,
        });
      }

      console.log(this.relatedObject);
    } else {
      // this.relatedForm.controls["relatedobjectid2"].setValue("");
      // this.relatedForm.controls["relatedobjectname2"].setValue("");
      // this.relatedObject = [];
    }
  }

  parentObjectChange(event: { value: string; label: any }) {
    console.log("parentObjectChange", event);
    if (event.value.trim() != "") {
      this.detailForm.controls["parentobjectid"].setValue(event.value);
      this.detailForm.controls["parentobjectname"].setValue(event.label);
    } else {
      this.detailForm.controls["parentobjectid"].setValue("");
      this.detailForm.controls["parentobjectname"].setValue("");
    }
  }

  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`,
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`,
        ),
        data: {
          metaobject: {
            objecttype: "Domain",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                value: activeObjects[i].id,
                label: activeObjects[i].name,
              });
            }
            this.parentObjects = objArr;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        },
      );
    });
  }

  retrieveLookupFields() {
    return new Promise((resolve, reject) => {
      console.log("LookupFields");
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`,
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`,
        ),
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
            fieldtype: "lookup",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      // this.dataService.getLookupFields(postOption).subscribe(
      this.dataService.getLookupFieldsAllVisibility(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            // this.metaobjectList = res.metaobject;
            // console.log(this.metaobjectList);
            // this.fields = res.data.metafields;
            // this.fieldsToDo = this.fields;
            this.metaobjectList.length = 0;

            const newMetaobjectList = res.metaobject;
            console.log(newMetaobjectList);
            this.metaobjectList.push(...newMetaobjectList);

            // this.relatedObjects.length == 0;
            const objArr1 = [
              { value: "", label: "--None--", referencefieldname: "" },
            ];
            for (const obj of this.metaobjectList) {
              objArr1.push({
                value: obj.id,
                label: obj.name,
                referencefieldname: obj.lookupfield.metafieldname,
              });
            }
            this.relatedObjects = objArr1;

            console.log(
              "relatedObjects!!!!!!!!!!!!!!!!!!!!!",
              this.relatedObjects,
            );

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No  metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No  metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
          // this.metalayoutbutton.push(button);
        },
      );
    });
  }

  retrieveLookupFields2() {
    return new Promise((resolve, reject) => {
      console.log("LookupFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`,
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`,
        ),
        data: {
          metafield: {
            metaobjectid: this.relatedObjectId,
            metaobjectname: this.relatedObjectName,
            fieldtype: "lookup",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      // this.dataService.getLookupFields(postOption).subscribe(
      this.dataService.getLookupFieldsAllVisibility(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            // this.metaobjectList = res.metaobject;
            // console.log(this.metaobjectList);
            // this.fields = res.data.metafields;
            // this.fieldsToDo = this.fields;
            this.metaobjectList2.length = 0;

            const newMetaobjectList = res.metaobject;
            console.log(newMetaobjectList);
            this.metaobjectList2.push(...newMetaobjectList);

            // this.relatedObjects.length == 0;
            const objArr1 = [
              { value: "", label: "--None--", referencefieldname: "" },
            ];
            for (const obj of this.metaobjectList2) {
              objArr1.push({
                value: obj.id,
                label: obj.name,
                referencefieldname: obj.lookupfield.metafieldname,
              });
            }
            this.relatedObjects2 = objArr1;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No  metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No  metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
          // this.metalayoutbutton.push(button);
        },
      );
    });
  }

  getReportTypeById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`,
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`,
      ),
      data: {
        reporttype: {
          id: this.reportTypeId,
        },
      },
    };
    console.log(this.reportTypeId);
    this.isLoading = true;
    this.dataService.getReportTypeById(postOption).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // this.reporttype = res.data.reporttype;
          const report = res.data.reporttype;

          // console.log("Doneeee****", this.reporttype.name);
          // if (this.reporttype != null) {
          // this.metaLayoutId = this.metaglobalaction.metalayoutid;
          // this.metaactionId = this.metaglobalaction.id;
          // this.metaactionName = this.metaglobalaction.name;
          // this.detailForm.controls["primaryobject"].setValue(
          //   this.reporttype.primaryobjectname
          // );
          this.detailForm.controls["label"].setValue(report.labelname);
          this.detailForm.controls["primaryobject"].setValue(
            report.primaryobjectname,
          );
          this.detailForm.controls["name"].setValue(report.name);
          this.detailForm.controls["description"].setValue(report.description);

          this.retrievedObjectName = report.primaryobjectname;
          this.detailForm.controls["category"].setValue(report.category);

          // this.detailForm.controls["deploymentStatus"].setValue(
          //   this.reporttype.deployed
          // );

          if (report.deployed === false) {
            this.detailForm.controls["deploymentStatus"].setValue("false");
          } else {
            this.detailForm.controls["deploymentStatus"].setValue("true");
          }

          // this.detailForm.controls["parentobjectid"].setValue(
          //   "po9D000000k85TE"
          // );
          // }

          // this.detailForm.controls["name"].setValue(this.reporttype.)

          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      },
    );
  }

  cancel() {
    this.router.navigateByUrl("/home/reporttypes");
  }
  save() {
    this.isLoading = false;
    this.isError = false;

    if (
      this.detailForm.controls["primaryobject"].value.toString().trim() == ""
    ) {
      this.showWarning("Object is mandatory");
      return;
    }

    if (this.detailForm.controls["label"].value.toString().trim() == "") {
      this.showWarning("Report type label is mandatory");
      return;
    }
    if (this.detailForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Report type name is mandatory");
      return;
    }

    if (this.detailForm.invalid) {
      this.errorMessage = "The fields [Label] and [Name] are mandatory.";
      return;
    }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.reportTypeId = this.guid.getGUID("reporttype");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`,
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`,
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        reporttype: {
          primaryobjectname: this.metaobjectName,
          mode: this.mode,
          id: this.reportTypeId,
          name: this.detailForm.controls["name"].value,
          labelname: this.detailForm.controls["label"].value,
          description: this.detailForm.controls["description"].value,
          category: this.detailForm.controls["category"].value,
          deployed:
            this.detailForm.controls["deploymentStatus"].value === "true",
          reporttyperelation: [],
          reporttypesection: [],
        },
      },
    };

    console.log("postOption", postOption);

    var arrReporttypeRelation = [];

    for (let reportTypeRelation of this.relatedObject) {
      if (this.mode.toLowerCase() == "new") {
        this.reportTypeRelationId = this.guid.getGUID("reporttyperelation");
      }
      var reporttyperelation = {
        // organizationid: localStorage.getItem("crm_orgid"),
        // userid: localStorage.getItem("crm_userid"),
        // username: localStorage.getItem("crm_username"),
        // useralias: localStorage.getItem("crm_useralias"),
        // data: {
        // recordtypelayout: {
        relationobjectname: reportTypeRelation.relatedobjectname,
        mode: this.mode,
        id: this.reportTypeRelationId,
        reporttypeid: this.reportTypeId,
        level: reportTypeRelation.level,
        referencefieldname: reportTypeRelation.referencefieldname,
        outerjoin: reportTypeRelation.outerjoin,
      };
      arrReporttypeRelation.push(reporttyperelation);
    }

    var arrReporttypeSection = [];

    var reportTypeSectionAddId = this.guid.getGUID("reporttypesection");

    console.log(this.relatedObject);
    for (let reportTypeSection of this.relatedObject) {
      if (this.mode.toLowerCase() == "new") {
        this.reportTypeSectionId = this.guid.getGUID("reporttypesection");
      }
      var reporttypesection = {
        sectionname: reportTypeSection.relatedobjectname,
        metaobjectid: reportTypeSection.relatedobjectid,
        mode: this.mode,
        id: this.reportTypeSectionId,
        reporttypeid: this.reportTypeId,
      };
      arrReporttypeSection.push(reporttypesection);
    }

    var reporttypesectionadd = {
      sectionname: this.metaobjectName,
      metaobjectid: this.metaobjectId,
      mode: this.mode,
      id: reportTypeSectionAddId,
      reporttypeid: this.reportTypeId,
    };

    arrReporttypeSection.push(reporttypesectionadd);

    postOption.data.reporttype.reporttyperelation = arrReporttypeRelation;
    postOption.data.reporttype.reporttypesection = arrReporttypeSection;

    console.log(postOption);

    this.isLoading = true;
    this.dataService.upsertReportType(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("/home/reporttypes");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      },
    );
  }
}
